export class EntityActivityLog {
    id?: number;
    entityActivityLogId?: number;
    activityLogId?: number;
    entityId: number;
    entityTypeId: number;
}

export class ActivityLogRequest {
    activityLog: ActivityLog;
}

export class ActivityLog {
    id: number;
    activityLogId: number;
    logIconId: number;
    createdBy: number;
    userName: string;
    dateCreated: string;
    icon: ActivityLogIcon;
    message: string;
    entityActivityLogs: EntityActivityLog[];
}

export class ActivityLogIcon {
    logIconId: number;
    name: string;
    source: string;
    tag: string;
    sourceKind: string;
    shortcut: string;
    isSelectable: boolean;
}

export const IconSourceKinds = {
    GoogleIcon: "GoogleIcon",
    Url: "Url"
}

export interface UpdateActivityLogsResponse {
    updated: ActivityLog[];
    created: ActivityLog[];
    deleted: ActivityLog[];
}

export enum ActivityLogIconsEnum {
    Email = 1,
    Sms = 2,
    Call = 3,
    Generic = 4,
    Document = 5,
    Reminder = 6
}
